import React from 'react';
import { CircleHelp } from 'lucide-react';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface InfoTooltipProps {
  title?: string;
  description: string | React.ReactNode;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  sideOffset?: number;
}

const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  description,
  className = 'w-4 h-4 text-muted-foreground cursor-pointer',
  side = 'right',
  align = 'start',
  sideOffset = 5,
}) => {
  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <CircleHelp className={className} />
        </TooltipTrigger>
        <TooltipContent
          className="max-w-[300px] p-4 z-[100] relative"
          side={side}
          align={align}
          sideOffset={sideOffset}
        >
          {title && <h4 className="font-semibold mb-2 text-lg">{title}</h4>}
          <div className="text-sm space-y-1">
            {typeof description === 'string' ? (
              <p>{description}</p>
            ) : (
              description
            )}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default InfoTooltip;
